module.exports = __webpack_public_path__ + "img/copy-link.897c29e.svg?v=1764903765445";